// libs
import { createSelector } from 'reselect';
export const experimentVariants = (state) => state.abExperiments;
export const getABExperimentVariants = createSelector([experimentVariants], (abExperimentVariants) => abExperimentVariants);
export const getABExperimentVariant = (state, experimentId) => {
    const abExperimentVariants = getABExperimentVariants(state);
    const variant = abExperimentVariants[experimentId];
    if (variant === undefined) {
        return { isEligible: false };
    }
    return { isEligible: true, variant };
};
